import { PageClient } from '../api/APIClient';


export const getPage = async (): Promise<number> => {

  const page = document.querySelector('script[data-c7-page]')?.getAttribute('data-c7-page');

  return !!page ? +page : await new PageClient().getCurrentPageId();
}

export const setPage = async <T extends {page:number}>(component: T): Promise<void> => {
  component.page = await getPage();
}


